import {
  ACTION_MASTERDATA_START,
  ACTION_MASTERDATA_END,
  SEARCH_STORES,
  C2C_ZONE,
  STORE_LOCATIONS,
  STORE_CITY,
  STORE_REGION,
  STORE_ZONE,
  GET_SERVICE_PRICE,
  SAVED_STORES,
  STORE_STATE,
  GET_CITY_COUNT,
  STORE_PARENT_ZONE,
  UPDATE_STORES,
  GET_LOCATION_COUNT,
  SAVED_STATE,
  GET_STATE_COUNT,
  GET_ZONE_COUNT,
  SAVED_CITIES,
  UPDATE_CITIES,
  STORE_PINCODE,
  UPDATE_STATE,
  SAVED_ZONE,
  UPDATE_ZONE,
  GET_SERVICE_NAME,
  GET_PINCODE_COUNT,
  SAVE_SERVICE_PRICE,
  UPDATE_SERVICE_PRICE,
  GET_LOCATION_DATA,
  SAVED_FILES,
  ACTION_ZONE_START,
  ACTION_ZONE_END,
  GET_ZONE_DATA,
  LOCATION_BASED_ZONE,
  STORE_INTERCITY,
  SAVED_INTERCITY_ROUTE,
  UPDATED_INTERCITY_ROUTE,
  GET_INTERCITY_COUNT,
  FETCHING_INTERCITY_ROUTE_LIST,
  FETCHED_INTERCITY_ROUTE_LIST,
  GET_DRIVER_COUNT,
  SEARCH_DRIVERS,
  SAVED_DRIVER,
  UPDATE_DRIVER,
  GET_MAKE_LIST,
  SEARCH_MAKE_LIST,
} from './masterData.actiontype';
import axiosService from '../../../inits/axios';
import { setToasterMessage } from '../commonAction/common.action';
import { config } from '../../../utils/constants/api.constants';
import {
  ErrorMessage,
  AlertType,
  Country,
  Vehicle,
} from '../../../utils/constants/values.constants';
import { convertObjectToParams } from '../../../utils/utils';

export const computeMasterDataHost = () => {
  const countryCode = localStorage.getItem('country');
  const vehicleType = localStorage.getItem('vehicleType');

  if (countryCode === Country.TH && vehicleType === Vehicle.CAR) {
    return config.api.masterdata.host_th;
  }

  if (countryCode === Country.KSA && vehicleType === Vehicle.CAR) {
    return config.api.masterdata.host_me;
  }

  if (countryCode === Country.ID && vehicleType === Vehicle.CAR) {
    return config.api.masterdata.host_id;
  }

  return config.api.masterdata.host;
};

export const searchStoreLocations =
  (params = {}, options = { hideLoader: false }) =>
  async (dispatch) => {
    if (!options?.hideLoader) {
      dispatch({ type: ACTION_MASTERDATA_START });
    }

    const url =
      computeMasterDataHost() +
      config.api.masterdata.api_v2 +
      config.api.masterdata.masterData +
      config.api.masterdata.storeLocation +
      convertObjectToParams(params);

    try {
      const data = await axiosService.get(url);
      dispatch({ type: STORE_LOCATIONS, payload: data.data });
    } catch (e) {
      dispatch({ type: ACTION_MASTERDATA_END });
    }
  };

export const getLocationCount =
  (params = {}) =>
  async (dispatch) => {
    dispatch({ type: ACTION_MASTERDATA_START });
    const url =
      computeMasterDataHost() +
      config.api.masterdata.api_v2 +
      config.api.masterdata.masterData +
      config.api.masterdata.storeLocation +
      config.api.masterdata.count +
      convertObjectToParams(params);
    try {
      const data = await axiosService.get(url);
      dispatch({ type: GET_LOCATION_COUNT, payload: data.data });
    } catch (e) {
      dispatch({ type: ACTION_MASTERDATA_END });
    }
  };

export const getDriverCount =
  (params = {}) =>
  async (dispatch) => {
    dispatch({ type: ACTION_MASTERDATA_START });
    const url =
      config.api.resourcePlanner.baseUrl +
      config.api.resourcePlanner.get +
      config.api.masterdata.count +
      convertObjectToParams(params);

    try {
      const data = await axiosService.get(url);

      dispatch({ type: GET_DRIVER_COUNT, payload: data.data });
    } catch (e) {
      dispatch({ type: ACTION_MASTERDATA_END });
    }
  };

export const searchDrivers =
  (params = {}) =>
  async (dispatch) => {
    dispatch({ type: ACTION_MASTERDATA_START });

    const url =
      config.api.resourcePlanner.baseUrl +
      config.api.resourcePlanner.get +
      convertObjectToParams(params);

    try {
      const data = await axiosService.get(url);
      dispatch({ type: SEARCH_DRIVERS, payload: data.data });
    } catch (e) {
      dispatch({ type: ACTION_MASTERDATA_END });
    }
  };

export const saveDriver = (body) => async (dispatch) => {
  let newbody = body?.saveData?.[0] ? body.saveData[0] : body[0];
  dispatch({ type: ACTION_MASTERDATA_START });

  const url =
    config.api.resourcePlanner.baseUrl + config.api.resourcePlanner.get;

  try {
    const data = await axiosService.post(url, newbody);
    dispatch(
      setToasterMessage({
        toasterMessage: 'Driver saved successfully!',
        showToaster: true,
        toasterType: AlertType.SUCCESS,
      })
    );
    dispatch({
      type: SAVED_DRIVER,
      payload: data.data ? data.data : 'success',
    });
  } catch (e) {
    let errorMessage = ErrorMessage.unknown;
    if (e && e.response && e.response.data && e.response.data.message) {
      errorMessage = e.response.data.message;
    } else if (e.response.status && e.response.status === 400) {
      errorMessage = ErrorMessage.status400;
    }
    dispatch(
      setToasterMessage({
        toasterMessage: errorMessage,
        showToaster: true,
        toasterType: AlertType.ERROR,
      })
    );

    dispatch({ type: ACTION_MASTERDATA_END });
  }
};

export const updateDriver = (body) => async (dispatch) => {
  let newbody = body.saveData[0];
  dispatch({ type: ACTION_MASTERDATA_START });

  const url =
    config.api.resourcePlanner.baseUrl +
    config.api.resourcePlanner.get +
    '?id=' +
    body.id;

  try {
    newbody['id'] = body.id;
    const data = await axiosService.post(url, newbody);
    dispatch(
      setToasterMessage({
        toasterMessage: 'Driver updated successfully!',
        showToaster: true,
        toasterType: AlertType.SUCCESS,
      })
    );
    dispatch({
      type: UPDATE_DRIVER,
      payload: data.data ? data.data : 'success',
    });
  } catch (e) {
    if (e && e.response && e.response.data && e.response.data.message) {
      dispatch(
        setToasterMessage({
          toasterMessage: e.response.data.message,
          showToaster: true,
          toasterType: AlertType.ERROR,
        })
      );
    }
    dispatch({ type: ACTION_MASTERDATA_END });
  }
};

export const searchStoreState =
  (params = {}) =>
  async (dispatch) => {
    const url =
      computeMasterDataHost() +
      config.api.masterdata.api_v1 +
      config.api.masterdata.masterData +
      config.api.masterdata.state +
      convertObjectToParams(params);

    try {
      const data = await axiosService.get(url);
      dispatch({ type: STORE_STATE, payload: data.data });
    } catch (e) {
      dispatch({ type: ACTION_MASTERDATA_END });
    }
  };

export const searchStoreCities =
  (params = {}) =>
  async (dispatch) => {
    const url =
      computeMasterDataHost() +
      config.api.masterdata.api_v1 +
      config.api.masterdata.masterData +
      config.api.masterdata.city +
      convertObjectToParams(params);

    try {
      const data = await axiosService.get(url);
      dispatch({ type: STORE_CITY, payload: data.data });
    } catch (e) {
      dispatch({ type: ACTION_MASTERDATA_END });
    }
  };

export const getMakeList =
  (params = {}, searching = false) =>
  async (dispatch) => {
    const url =
      computeMasterDataHost() +
      config.api.masterdata.api_v2 +
      config.api.masterdata.masterData +
      '/make' +
      convertObjectToParams(params);

    try {
      const data = await axiosService.get(url);

      if (searching) {
        dispatch({ type: SEARCH_MAKE_LIST, payload: data.data });
      } else {
        dispatch({ type: GET_MAKE_LIST, payload: data.data });
      }
    } catch (e) {
      dispatch({ type: ACTION_MASTERDATA_END });
    }
  };

export const searchStoreRegions =
  (params = {}) =>
  async (dispatch) => {
    const url =
      computeMasterDataHost() +
      config.api.masterdata.api_v1 +
      config.api.masterdata.masterData +
      config.api.masterdata.region +
      convertObjectToParams(params);

    try {
      const data = await axiosService.get(url);
      dispatch({ type: STORE_REGION, payload: data.data });
    } catch (e) {
      dispatch({ type: ACTION_MASTERDATA_END });
      console.error('Error::', e);
    }
  };

export const getCityCount =
  (params = {}) =>
  async (dispatch) => {
    dispatch({ type: ACTION_MASTERDATA_START });
    const url =
      computeMasterDataHost() +
      config.api.masterdata.api_v1 +
      config.api.masterdata.masterData +
      config.api.masterdata.city +
      config.api.masterdata.count +
      convertObjectToParams(params);

    try {
      const data = await axiosService.get(url);
      dispatch({ type: GET_CITY_COUNT, payload: data.data });
    } catch (e) {
      dispatch({ type: ACTION_MASTERDATA_END });
    }
  };

export const searchStores =
  (params = {}) =>
  async (dispatch) => {
    dispatch({ type: ACTION_MASTERDATA_START });

    const url =
      computeMasterDataHost() +
      config.api.masterdata.api_v2 +
      config.api.masterdata.masterData +
      config.api.masterdata.storeLocation +
      convertObjectToParams(params) +
      '&allDetails=true';

    try {
      const data = await axiosService.get(url);
      dispatch({ type: SEARCH_STORES, payload: data.data });
    } catch (e) {
      dispatch({ type: ACTION_MASTERDATA_END });
    }
  };

export const searchAllVerticalStores =
  (params = {}) =>
  async (dispatch) => {
    dispatch({ type: ACTION_MASTERDATA_START });

    const { api_v2, masterData, storeLocation } = config.api.masterdata;
    const url = `${computeMasterDataHost()}${api_v2}${masterData}${storeLocation}${convertObjectToParams(
      params
    )}&allVerticals=true&allDetails=false`;

    try {
      const data = await axiosService.get(url);
      dispatch({ type: SEARCH_STORES, payload: data.data });
    } catch (e) {
      dispatch({ type: ACTION_MASTERDATA_END });
    }
  };

export const saveCityRecords = (body) => async (dispatch) => {
  let newbody = body.saveCityData[0];
  dispatch({ type: ACTION_MASTERDATA_START });
  const url =
    computeMasterDataHost() +
    config.api.masterdata.api_v1 +
    config.api.masterdata.masterData +
    config.api.masterdata.city;

  try {
    const data = await axiosService.post(url, newbody);
    dispatch(
      setToasterMessage({
        toasterMessage: 'City saved successfully!',
        showToaster: true,
        toasterType: AlertType.SUCCESS,
        statusCode: 200,
      })
    );
    dispatch({
      type: SAVED_CITIES,
      payload: data.data ? data.data : 'success',
    });
  } catch (e) {
    if (e && e.response && e.response.data && e.response.data.message) {
      dispatch(
        setToasterMessage({
          toasterMessage: e.response.data.message,
          showToaster: true,
          toasterType: AlertType.ERROR,
          statusCode: e.response.status,
        })
      );
    }
    dispatch({ type: ACTION_MASTERDATA_END });
  }
};

export const saveStateRecords = (body) => async (dispatch) => {
  let newbody = body.saveStateData[0];
  dispatch({ type: ACTION_MASTERDATA_START });
  const url =
    computeMasterDataHost() +
    config.api.masterdata.api_v1 +
    config.api.masterdata.masterData +
    config.api.masterdata.state;

  try {
    const data = await axiosService.post(url, newbody);
    dispatch(
      setToasterMessage({
        toasterMessage: 'State saved successfully!',
        showToaster: true,
        toasterType: AlertType.SUCCESS,
        statusCode: 200,
      })
    );
    dispatch({ type: SAVED_STATE, payload: data.data ? data.data : 'success' });
  } catch (e) {
    if (e && e.response && e.response.data && e.response.data.message) {
      dispatch(
        setToasterMessage({
          toasterMessage: e.response.data.message,
          showToaster: true,
          toasterType: AlertType.ERROR,
          statusCode: e.response.status,
        })
      );
    }
    dispatch({ type: ACTION_MASTERDATA_END });
  }
};

export const saveZoneRecords = (body) => async (dispatch) => {
  let newbody = body.saveZoneData[0];
  dispatch({ type: ACTION_MASTERDATA_START });
  const url =
    computeMasterDataHost() +
    config.api.masterdata.api_v1 +
    config.api.masterdata.masterData +
    config.api.masterdata.zone;

  try {
    const data = await axiosService.post(url, newbody);
    dispatch(
      setToasterMessage({
        toasterMessage: 'Zone saved successfully!',
        showToaster: true,
        toasterType: AlertType.SUCCESS,
        statusCode: 200,
      })
    );
    dispatch({ type: SAVED_ZONE, payload: data.data ? data.data : 'success' });
  } catch (e) {
    if (e && e.response && e.response.data && e.response.data.message) {
      dispatch(
        setToasterMessage({
          toasterMessage: e.response.data.message,
          showToaster: true,
          toasterType: AlertType.ERROR,
          statusCode: e.response.status,
        })
      );
    }
    dispatch({ type: ACTION_MASTERDATA_END });
  }
};

export const updateCityRecord = (body) => async (dispatch) => {
  let newbody = body.saveCityData[0];
  dispatch({ type: ACTION_MASTERDATA_START });
  const url =
    computeMasterDataHost() +
    config.api.masterdata.api_v1 +
    config.api.masterdata.masterData +
    config.api.masterdata.city +
    '/' +
    body.id;

  try {
    const data = await axiosService.put(url, newbody);

    dispatch(
      setToasterMessage({
        toasterMessage: 'City updated successfully!',
        showToaster: true,
        toasterType: AlertType.SUCCESS,
        statusCode: 200,
      })
    );
    dispatch({
      type: UPDATE_CITIES,
      payload: data.data ? data.data : 'success',
    });
  } catch (e) {
    if (e && e.response && e.response.data && e.response.data.message) {
      dispatch(
        setToasterMessage({
          toasterMessage: e.response.data.message,
          showToaster: true,
          toasterType: AlertType.ERROR,
          statusCode: e.response.status,
        })
      );
    }
    dispatch({ type: ACTION_MASTERDATA_END });
  }
};

export const updateStateRecord = (body) => async (dispatch) => {
  let newbody = body.saveStateData[0];
  dispatch({ type: ACTION_MASTERDATA_START });
  const url =
    computeMasterDataHost() +
    config.api.masterdata.api_v1 +
    config.api.masterdata.masterData +
    config.api.masterdata.state +
    '/' +
    body.id;

  try {
    const data = await axiosService.put(url, newbody);
    dispatch(
      setToasterMessage({
        toasterMessage: 'State updated successfully!',
        showToaster: true,
        toasterType: AlertType.SUCCESS,
        statusCode: 200,
      })
    );
    dispatch({
      type: UPDATE_STATE,
      payload: data.data ? data.data : 'success',
    });
  } catch (e) {
    if (e && e.response && e.response.data && e.response.data.message) {
      dispatch(
        setToasterMessage({
          toasterMessage: e.response.data.message,
          showToaster: true,
          toasterType: AlertType.ERROR,
          statusCode: e.response.status,
        })
      );
    }
    dispatch({ type: ACTION_MASTERDATA_END });
  }
};

export const updateZoneRecord = (body) => async (dispatch) => {
  let newbody = body.saveZoneData[0];
  dispatch({ type: ACTION_MASTERDATA_START });
  const url =
    computeMasterDataHost() +
    config.api.masterdata.api_v1 +
    config.api.masterdata.masterData +
    config.api.masterdata.zone +
    '/' +
    body.id;
  try {
    const data = await axiosService.put(url, newbody);
    dispatch(
      setToasterMessage({
        toasterMessage: 'Zone updated successfully!',
        showToaster: true,
        toasterType: AlertType.SUCCESS,
        statusCode: 200,
      })
    );
    dispatch({ type: UPDATE_ZONE, payload: data.data ? data.data : 'success' });
  } catch (e) {
    if (e && e.response && e.response.data && e.response.data.message) {
      dispatch(
        setToasterMessage({
          toasterMessage: e.response.data.message,
          showToaster: true,
          toasterType: AlertType.ERROR,
          statusCode: e.response.status,
        })
      );
    }
    dispatch({ type: ACTION_MASTERDATA_END });
  }
};

export const saveStore = (body) => async (dispatch) => {
  let newbody = body?.saveData?.[0] ? body.saveData[0] : body[0];
  dispatch({ type: ACTION_MASTERDATA_START });
  const url =
    computeMasterDataHost() +
    config.api.masterdata.api_v2 +
    config.api.masterdata.masterData +
    config.api.masterdata.storeLocation;
  try {
    const data = await axiosService.post(url, newbody);
    dispatch(
      setToasterMessage({
        toasterMessage: 'Location saved successfully!',
        showToaster: true,
        toasterType: AlertType.SUCCESS,
      })
    );
    dispatch({
      type: SAVED_STORES,
      payload: data.data ? data.data : 'success',
    });
  } catch (e) {
    let errorMessage = ErrorMessage.unknown;
    if (e && e.response && e.response.data && e.response.data.message) {
      errorMessage = e.response.data.message;
    } else if (e.response.status && e.response.status === 400) {
      errorMessage = ErrorMessage.status400;
    }
    dispatch(
      setToasterMessage({
        toasterMessage: errorMessage,
        showToaster: true,
        toasterType: AlertType.ERROR,
      })
    );

    dispatch({ type: ACTION_MASTERDATA_END });
  }
};

export const uploadFile = (body) => async (dispatch) => {
  let newbody = body.data;
  var formData = new FormData();
  formData.append('file', newbody.file);

  dispatch({ type: ACTION_MASTERDATA_START });
  const url =
    computeMasterDataHost() +
    config.api.masterdata.api_v1 +
    config.api.masterdata.masterData +
    `/${newbody.type}` +
    config.api.masterdata.bulk_csv;
  try {
    const data = await axiosService.post(url, formData);
    dispatch(
      setToasterMessage({
        toasterMessage: 'File Upload successfully!',
        showToaster: true,
        toasterType: AlertType.SUCCESS,
      })
    );
    dispatch({ type: SAVED_FILES, payload: data.data ? data.data : 'success' });
  } catch (e) {
    if (e.response.status === 500 || e.response.data)
      dispatch(
        setToasterMessage({
          toasterMessage:
            e.response.status === 500
              ? e.response.data.error
              : e.response.data && e.response.data.message,
          showToaster: true,
          toasterType: AlertType.ERROR,
        })
      );
    dispatch({ type: ACTION_MASTERDATA_END });
  }
};

export const updateStore = (body) => async (dispatch) => {
  let newbody = body.saveData[0];
  dispatch({ type: ACTION_MASTERDATA_START });
  const url =
    computeMasterDataHost() +
    config.api.masterdata.api_v2 +
    config.api.masterdata.masterData +
    config.api.masterdata.storeLocation +
    '/' +
    body.id;
  try {
    const data = await axiosService.put(url, newbody);
    dispatch(
      setToasterMessage({
        toasterMessage: 'Location updated successfully!',
        showToaster: true,
        toasterType: AlertType.SUCCESS,
      })
    );
    dispatch({
      type: UPDATE_STORES,
      payload: data.data ? data.data : 'success',
    });
  } catch (e) {
    if (e && e.response && e.response.data && e.response.data.message) {
      dispatch(
        setToasterMessage({
          toasterMessage: e.response.data.message,
          showToaster: true,
          toasterType: AlertType.ERROR,
        })
      );
    }
    dispatch({ type: ACTION_MASTERDATA_END });
  }
};

export const getStateCount =
  (params = {}) =>
  async (dispatch) => {
    dispatch({ type: ACTION_MASTERDATA_START });
    const url =
      computeMasterDataHost() +
      config.api.masterdata.api_v1 +
      config.api.masterdata.masterData +
      config.api.masterdata.state +
      config.api.masterdata.count +
      convertObjectToParams(params);
    try {
      const data = await axiosService.get(url);
      dispatch({ type: GET_STATE_COUNT, payload: data.data });
    } catch (e) {
      dispatch({ type: ACTION_MASTERDATA_END });
    }
  };

export const searchStoreZone =
  (params = {}) =>
  async (dispatch) => {
    dispatch({ type: ACTION_MASTERDATA_START });
    const url =
      computeMasterDataHost() +
      config.api.masterdata.api_v1 +
      config.api.masterdata.masterData +
      config.api.masterdata.zone +
      convertObjectToParams(params);
    let data;
    try {
      data = await axiosService.get(url);
      dispatch({ type: STORE_ZONE, payload: data.data });
    } catch (e) {
      dispatch({ type: ACTION_MASTERDATA_END });
    }
  };

export const searchAllVerticalsStoreZone =
  (params = {}) =>
  async (dispatch) => {
    dispatch({ type: ACTION_MASTERDATA_START });

    const { host, api_v1, masterData, zone } = config.api.masterdata;
    const url = `${host}${api_v1}${masterData}${zone}${convertObjectToParams(
      params
    )}&allVerticals=true`;

    let data;
    try {
      data = await axiosService.get(url);
      dispatch({ type: STORE_ZONE, payload: data.data });
    } catch (e) {
      dispatch({ type: ACTION_MASTERDATA_END });
    }
  };

export const searchZone =
  (params = {}) =>
  async (dispatch) => {
    dispatch({ type: ACTION_ZONE_START });
    const url =
      computeMasterDataHost() +
      config.api.masterdata.api_v1 +
      config.api.masterdata.masterData +
      config.api.masterdata.zone +
      convertObjectToParams(params);
    let data;
    try {
      data = await axiosService.get(url);
      dispatch({ type: GET_ZONE_DATA, payload: data.data });
    } catch (e) {
      dispatch({ type: ACTION_ZONE_END });
    }
  };

export const getZoneList = () => async (dispatch) => {
  dispatch({ type: ACTION_MASTERDATA_START });
  const url =
    computeMasterDataHost() +
    config.api.masterdata.api_v2 +
    config.api.masterdata.masterData +
    config.api.masterdata.storeLocation +
    config.api.masterdata.c2c_zone;
  let data;
  try {
    data = await axiosService.get(url);
    dispatch({ type: C2C_ZONE, payload: data.data });
  } catch (e) {
    dispatch({ type: ACTION_MASTERDATA_END });
  }
};

export const getZoneLocation = (code) => async (dispatch) => {
  dispatch({ type: ACTION_MASTERDATA_START });
  const url =
    computeMasterDataHost() +
    config.api.masterdata.api_v1 +
    config.api.masterdata.masterData +
    config.api.masterdata.zone +
    config.api.masterdata.code +
    '/' +
    code +
    config.api.masterdata.location;
  let data;
  try {
    data = await axiosService.get(url);
    dispatch({ type: LOCATION_BASED_ZONE, payload: data.data });
  } catch (e) {
    dispatch({ type: ACTION_MASTERDATA_END });
  }
};

export const searchParentZone =
  (params = {}) =>
  async (dispatch) => {
    dispatch({ type: ACTION_MASTERDATA_START });
    const url =
      computeMasterDataHost() +
      config.api.masterdata.api_v1 +
      config.api.masterdata.masterData +
      config.api.masterdata.zone +
      convertObjectToParams(params);
    let data;
    try {
      data = await axiosService.get(url);
      dispatch({ type: STORE_PARENT_ZONE, payload: data.data });
    } catch (e) {
      dispatch({ type: ACTION_MASTERDATA_END });
    }
  };

export const getZoneCount =
  (params = {}) =>
  async (dispatch) => {
    dispatch({ type: ACTION_MASTERDATA_START });
    const url =
      computeMasterDataHost() +
      config.api.masterdata.api_v1 +
      config.api.masterdata.masterData +
      config.api.masterdata.zone +
      config.api.masterdata.count +
      convertObjectToParams(params);
    try {
      const data = await axiosService.get(url);
      dispatch({ type: GET_ZONE_COUNT, payload: data.data });
    } catch (e) {
      dispatch({ type: ACTION_MASTERDATA_END });
    }
  };

export const getPincodeCount =
  (params = {}) =>
  async (dispatch) => {
    dispatch({ type: ACTION_MASTERDATA_START });
    const url =
      computeMasterDataHost() +
      config.api.masterdata.api_v1 +
      config.api.masterdata.masterData +
      config.api.masterdata.pincode +
      config.api.masterdata.count +
      convertObjectToParams(params);
    try {
      const data = await axiosService.get(url);
      dispatch({ type: GET_PINCODE_COUNT, payload: data.data });
    } catch (e) {
      dispatch({ type: ACTION_MASTERDATA_END });
    }
  };

export const getServiceName = () => async (dispatch) => {
  dispatch({ type: ACTION_MASTERDATA_START });
  const url =
    computeMasterDataHost() +
    config.api.masterdata.api_v1 +
    config.api.masterdata.masterData +
    config.api.masterdata.pricing +
    config.api.masterdata.service;
  try {
    const data = await axiosService.get(url);
    dispatch({ type: GET_SERVICE_NAME, payload: data.data });
  } catch (e) {
    dispatch({ type: ACTION_MASTERDATA_END });
  }
};

export const getServicePrice = () => async (dispatch) => {
  dispatch({ type: ACTION_MASTERDATA_START });
  const url =
    computeMasterDataHost() +
    config.api.masterdata.api_v1 +
    config.api.masterdata.masterData +
    config.api.masterdata.pricing;
  try {
    const data = await axiosService.get(url);
    dispatch({ type: GET_SERVICE_PRICE, payload: data.data });
  } catch (e) {
    dispatch({ type: ACTION_MASTERDATA_END });
  }
};

export const saveServicePrice = (body) => async (dispatch) => {
  dispatch({ type: ACTION_MASTERDATA_START });
  const url =
    computeMasterDataHost() +
    config.api.masterdata.api_v1 +
    config.api.masterdata.masterData +
    config.api.masterdata.pricing;
  try {
    const data = await axiosService.post(url, body.saveData);
    dispatch(
      setToasterMessage({
        toasterMessage: 'Price saved Successfully!',
        showToaster: true,
        toasterType: AlertType.SUCCESS,
      })
    );

    dispatch({ type: SAVE_SERVICE_PRICE, payload: data.data });
  } catch (e) {
    dispatch(
      setToasterMessage({
        toasterMessage: 'Something went wrong!',
        showToaster: true,
        toasterType: AlertType.ERROR,
      })
    );
    dispatch({ type: ACTION_MASTERDATA_END });
  }
};

export const updateServicePrice = (body) => async (dispatch) => {
  dispatch({ type: ACTION_MASTERDATA_START });

  const url =
    computeMasterDataHost() +
    config.api.masterdata.api_v1 +
    config.api.masterdata.masterData +
    config.api.masterdata.pricing +
    '/' +
    body.locationId;

  try {
    const data = await axiosService.put(url, body.saveData);
    dispatch(
      setToasterMessage({
        toasterMessage: 'Price updated Successfully!',
        showToaster: true,
        toasterType: AlertType.SUCCESS,
      })
    );
    dispatch({ type: UPDATE_SERVICE_PRICE, payload: data.data });
  } catch (e) {
    dispatch(
      setToasterMessage({
        toasterMessage: 'Something went wrong!',
        showToaster: true,
        toasterType: AlertType.ERROR,
      })
    );
    dispatch({ type: ACTION_MASTERDATA_END });
  }
};

export const getLocationData =
  (params = {}) =>
  async (dispatch) => {
    dispatch({ type: ACTION_MASTERDATA_START });
    const url =
      computeMasterDataHost() +
      config.api.masterdata.api_v1 +
      config.api.masterdata.masterData +
      config.api.masterdata.pricing +
      config.api.masterdata.placeType +
      params.location;
    try {
      const data = await axiosService.get(url);
      dispatch({ type: GET_LOCATION_DATA, payload: data.data });
    } catch (e) {
      dispatch({ type: ACTION_MASTERDATA_END });
    }
  };

export const searchStorePincode =
  (params = {}) =>
  async (dispatch) => {
    dispatch({ type: ACTION_MASTERDATA_START });

    const url =
      computeMasterDataHost() +
      config.api.masterdata.api_v1 +
      config.api.masterdata.masterData +
      config.api.masterdata.pincode +
      convertObjectToParams(params);

    try {
      const data = await axiosService.get(url);
      dispatch({ type: STORE_PINCODE, payload: data.data });
    } catch (e) {
      dispatch({ type: ACTION_MASTERDATA_END });
    }
  };

export const savePinCodeRecords = (body) => async (dispatch) => {
  let newbody = body.savePinCodeData;
  dispatch({ type: ACTION_MASTERDATA_START });
  const url =
    computeMasterDataHost() +
    config.api.masterdata.api_v1 +
    config.api.masterdata.masterData +
    config.api.masterdata.pincodeAddEdit;
  try {
    const data = await axiosService.post(url, newbody);
    dispatch(
      setToasterMessage({
        toasterMessage: 'Pincode saved successfully!',
        showToaster: true,
        toasterType: AlertType.SUCCESS,
        statusCode: 200,
      })
    );
    dispatch({ type: SAVED_ZONE, payload: data.data ? data.data : 'success' });
  } catch (e) {
    if (e && e.response && e.response.data && e.response.data.message) {
      dispatch(
        setToasterMessage({
          toasterMessage: e.response.data.message,
          showToaster: true,
          toasterType: AlertType.ERROR,
          statusCode: e.response.status,
        })
      );
    }
    dispatch({ type: ACTION_MASTERDATA_END });
  }
};

export const searchStoreIntercity =
  (params = {}) =>
  async (dispatch) => {
    dispatch({ type: ACTION_MASTERDATA_START });
    dispatch({ type: FETCHING_INTERCITY_ROUTE_LIST });

    const url =
      computeMasterDataHost() +
      config.api.masterdata.api_v2 +
      config.api.masterdata.masterData +
      config.api.masterdata.route +
      convertObjectToParams(params);

    try {
      const data = await axiosService.get(url);
      dispatch({ type: STORE_INTERCITY, payload: data.data });
    } catch (e) {
      dispatch({ type: ACTION_MASTERDATA_END });
    }

    dispatch({ type: FETCHED_INTERCITY_ROUTE_LIST });
  };

export const getIntercityCount =
  (params = {}) =>
  async (dispatch) => {
    dispatch({ type: ACTION_MASTERDATA_START });

    const url =
      computeMasterDataHost() +
      config.api.masterdata.api_v2 +
      config.api.masterdata.masterData +
      config.api.masterdata.route +
      config.api.masterdata.count +
      convertObjectToParams(params);

    try {
      const data = await axiosService.get(url);
      dispatch({ type: GET_INTERCITY_COUNT, payload: data.data });
    } catch (e) {
      dispatch({ type: ACTION_MASTERDATA_END });
    }
  };

export const addIntercityRoute = (body) => async (dispatch) => {
  const bodyData = body.finalData;

  dispatch({ type: ACTION_MASTERDATA_START });
  const url =
    computeMasterDataHost() +
    config.api.masterdata.api_v2 +
    config.api.masterdata.masterData +
    config.api.masterdata.route;
  try {
    const data = await axiosService.post(url, bodyData);

    dispatch(
      setToasterMessage({
        toasterMessage: 'Intercity route saved successfully!',
        showToaster: true,
        toasterType: AlertType.SUCCESS,
        statusCode: 200,
      })
    );
    dispatch({
      type: SAVED_INTERCITY_ROUTE,
      payload: data.data ? data.data : 'success',
    });
  } catch (e) {
    if (e && e.response && e.response.data && e.response.data.message) {
      dispatch(
        setToasterMessage({
          toasterMessage: e.response.data.message,
          showToaster: true,
          toasterType: AlertType.ERROR,
          statusCode: e.response.status,
        })
      );
    }
    dispatch({ type: ACTION_MASTERDATA_END });
  }
};

export const updateIntercityRoute = (body) => async (dispatch) => {
  dispatch({ type: ACTION_MASTERDATA_START });

  const bodyData = body.finalData;
  const url =
    computeMasterDataHost() +
    config.api.masterdata.api_v2 +
    config.api.masterdata.masterData +
    config.api.masterdata.route +
    '/' +
    body.code;

  try {
    const data = await axiosService.put(url, bodyData);

    dispatch(
      setToasterMessage({
        toasterMessage: 'Intercity route updated successfully!',
        showToaster: true,
        toasterType: AlertType.SUCCESS,
        statusCode: 200,
      })
    );

    dispatch({
      type: UPDATED_INTERCITY_ROUTE,
      payload: data.data ? data.data : 'success',
    });
  } catch (e) {
    if (e && e.response && e.response.data && e.response.data.message) {
      dispatch(
        setToasterMessage({
          toasterMessage: e.response.data.message,
          showToaster: true,
          toasterType: AlertType.ERROR,
          statusCode: e.response.status,
        })
      );
    }
    dispatch({ type: ACTION_MASTERDATA_END });
  }
};

export const getDOHNumber =
  (params = {}, setData, setDOHLoading) =>
  async () => {
    setDOHLoading(true);
    const url =
      config.api.inventory.host +
      config.api.inventory.api_version +
      config.api.inventory.inventory +
      config.api.inventory.location +
      config.api.inventory.holdingPeriod +
      convertObjectToParams(params);

    try {
      const data = await axiosService.get(url);
      setData(data.data);
      setDOHLoading(false);
    } catch (e) {
      setDOHLoading(false);
    }
  };

const FILE_VERSION = process.env.REACT_APP_FILE_VERSION;
